/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileExeSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileExeSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m19.86 6.122.074.44a7.623 7.623 0 0 1-.922 4.979c-.943 1.61-2.581 2.914-5.046 3.266l-.31.044-2.525-2.525.044-.31c.353-2.464 1.656-4.103 3.266-5.046a7.623 7.623 0 0 1 4.98-.922l.44.074Zm-1.102 1.103c-1.167-.097-2.524.144-3.685.824-1.23.72-2.257 1.942-2.61 3.84l1.63 1.63c1.898-.353 3.12-1.38 3.84-2.61.68-1.16.921-2.518.825-3.684Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.96 9.021c-.396-.396-.781-.396-1.178 0-.396.397-.396.782 0 1.179.397.396.782.396 1.179 0 .396-.397.396-.782 0-1.179Zm-5.101-.898 2.366-.07c-.639.463-1.997 1.727-2.322 3.08l-2.603.835-.884-.884 2.596-2.595a1.25 1.25 0 0 1 .847-.366Zm6.001 6 .069-2.365c-.41.586-1.601 1.872-3.08 2.322l-.835 2.602.884.884 2.596-2.595a1.25 1.25 0 0 0 .365-.848Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m10.626 14.472 3.536-3.535.884.883-3.536 3.536-.884-.884Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m5.917 17.173 2.99-2.96.88.888-2.991 2.96-.88-.888Zm2.985 1.16 2.174-2.145.878.89-2.174 2.144-.878-.89Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m19.86 6.121.074.44c.075.447.106.922.09 1.412a6.983 6.983 0 0 0-.09-.915l-.073-.44-.44-.074a7.623 7.623 0 0 0-4.98.922c-.513.3-.996.672-1.426 1.119l-1.156.034a1.25 1.25 0 0 0-.847.365l-2.348 2.348-.248-.248 2.596-2.595a1.25 1.25 0 0 1 .847-.366l1.156-.034c.43-.446.913-.818 1.426-1.119a7.623 7.623 0 0 1 4.98-.922l.44.073Zm-8.66 5.733a8.871 8.871 0 0 0-.024.162l-.045.31.063.062c.03-.194.067-.383.11-.567l-.104.033Zm.504 1.54-1.078 1.078.248.248 1.078-1.078-.248-.248Zm2.782 1.818-.472 1.47.12.12.523-1.627a8.58 8.58 0 0 1-.171.037Zm.312-3.144.248-.248-.884-.883-1.326 1.325-.285-.284a6.82 6.82 0 0 0-.088.407l.373.373 1.326-1.326.636.636Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m13.968 13.394-.248.248.373.373c1.898-.353 3.12-1.38 3.84-2.61.632-1.078.884-2.325.84-3.432a6.36 6.36 0 0 1-.84 2.936c-.72 1.23-1.942 2.257-3.84 2.61l-.125-.125Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.96 9.021c-.396-.396-.781-.396-1.178 0-.282.282-.363.559-.244.837.048-.113.13-.226.244-.34.397-.397.782-.397 1.179 0 .114.114.196.227.244.34.12-.278.038-.555-.244-.837ZM5.917 17.173l2.99-2.96.88.888-.248.245-.631-.638-2.744 2.715-.247-.25Zm5.159-.985-2.174 2.145.248.25 1.926-1.9.63.639.248-.245-.878-.89Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileExeSmall
};
